const TRIVIA_TOKEN_KEY = 'triviaToken';

function getStorage(): Storage | null {
    if (typeof window === 'undefined') return null;
    return window.sessionStorage;
}

export function getTriviaToken(): string | null {
    if (typeof window === 'undefined') return null;
    return (
        window.sessionStorage.getItem(TRIVIA_TOKEN_KEY) ||
        window.localStorage.getItem(TRIVIA_TOKEN_KEY)
    );
}

export function setTriviaToken(token: string | undefined | null): void {
    const storage = getStorage();
    if (!storage || !token) return;
    storage.setItem(TRIVIA_TOKEN_KEY, token);
}

export function setTriviaTokenFromResponse(response: { token?: string } | undefined | null): void {
    setTriviaToken(response?.token);
}

export function clearTriviaToken(): void {
    if (typeof window === 'undefined') return;
    window.sessionStorage.removeItem(TRIVIA_TOKEN_KEY);
    window.localStorage.removeItem(TRIVIA_TOKEN_KEY);
}
